angular.module('bribac.views.404', [
  'ngRoute'
])

  .config(function(
    $routeProvider
  ) {
    $routeProvider.otherwise({
      templateUrl: '404-view.html'
    })
  })
